module.exports = __webpack_public_path__ + "img/vib_web.aa5e5cba.png";